import {
  activateAccountPrefix,
  resetPasswordLegacyTokenPrefix,
  resetPasswordPath,
  resetPasswordTokenPrefix,
  signInPath,
  signUpPath,
} from 'common/config/urls';

export const AUTH_VIEW_PARAM = 'view';
export const AUTH_SOURCE_PARAM = 'source';
export const AUTH_RETURN_TO_PARAM = 'returnTo';
export const AUTH_EMAIL_PARAM = 'email';
export const AUTH_PRODUCT_PARAM = 'product';
export const AUTH_MODE_PARAM = 'mode';

export const AUTH_ROUTE_STATE_QUERY_PARAM_MAP = {
  mode: AUTH_MODE_PARAM,
  product: AUTH_PRODUCT_PARAM,
  returnTo: AUTH_RETURN_TO_PARAM,
  source: AUTH_SOURCE_PARAM,
  view: AUTH_VIEW_PARAM,
} as const;

export const AUTH_SOURCE_SECURE_PORTAL = 'secure-portal';

export const SIGN_IN_VIEW = {
  IDENTIFIER: 'identifier',
  PASSWORD: 'password',
  TWO_FACTOR: 'two-factor',
  TERMS: 'terms',
  PRODUCT_SELECTION: 'product-selection',
  WORKSPACE_SELECTION: 'workspace-selection',
} as const;

export type SignInView = (typeof SIGN_IN_VIEW)[keyof typeof SIGN_IN_VIEW];
export const SIGN_IN_VIEWS = Object.values(SIGN_IN_VIEW) as SignInView[];

export const SIGN_IN_PRODUCT = {
  PORTFOLIO: 'portfolio',
  COMPANY: 'company',
} as const;

export type SignInProduct = (typeof SIGN_IN_PRODUCT)[keyof typeof SIGN_IN_PRODUCT];
export const SIGN_IN_PRODUCTS = Object.values(SIGN_IN_PRODUCT) as SignInProduct[];

export const TWO_FACTOR_MODE = {
  VERIFY: 'verify',
  BACKUP_CODE: 'backup-code',
  SETUP: 'setup',
} as const;

export type TwoFactorMode = (typeof TWO_FACTOR_MODE)[keyof typeof TWO_FACTOR_MODE];
export const TWO_FACTOR_MODES = Object.values(TWO_FACTOR_MODE) as TwoFactorMode[];

export const SIGN_UP_VIEW = {
  FORM: 'form',
  CONFIRMATION: 'confirmation',
} as const;

export type SignUpView = (typeof SIGN_UP_VIEW)[keyof typeof SIGN_UP_VIEW];

export const RESET_PASSWORD_VIEW = {
  REQUEST: 'request',
  EMAIL_SENT: 'email-sent',
} as const;

export type ResetPasswordView = (typeof RESET_PASSWORD_VIEW)[keyof typeof RESET_PASSWORD_VIEW];

export const AUTH_RESTRICTED_RETURN_TO_PREFIXES = [
  signInPath,
  signUpPath,
  resetPasswordPath,
  resetPasswordTokenPrefix,
  resetPasswordLegacyTokenPrefix,
  activateAccountPrefix,
] as const;
